<template>
  <div class="app" @click="quan">
    <div class="title">
      <div class="center-content1 flex">
        <img src="./assets/logo.png" alt="" class="img-log" />
        <div>
          <ul class="left-ul">
            <li :class="{ active: value == '1' }" @click="qiehuan('1')">首页</li>
            <li :class="{ active: value == '2' }" @click="qiehuan('2')">关于我们</li>
            <li :class="{ active: value == '3' }" @click="qiehuan('3')">荣誉资质</li>
            <li :class="{ active: value == '4' }" class="ding" @mouseenter="changeActive()" @mouseleave="removeActive()"
              @click.stop="qiehuan('4')">
              数据治理
              <div>
                <div class="hidden-div" v-if="ishidden">
                  <p @click.stop="zixun()">数据治理咨询</p>
                  <p @click.stop="nengli()">数据治理能力</p>
                </div>
              </div>
            </li>
            <li :class="{ active: value == '5' }" class="ding" @mouseenter="changeActive1()" @mouseleave="removeActive1()"
              @click.stop="qiehuan('5')">
              智能制造
              <div class="hidden-div1" v-if="ishidden1">
                <p @click.stop="tophm()">PHM</p>
                <p @click.stop="toles()">LES</p>
              </div>
            </li>
            <li :class="{ active: value == '6' }" @click="qiehuan('6')">
              服务客户
            </li>
            <!-- <li :class="{ active: value == '7' }" @click="qiehuan('7')">
              联系我们
            </li> -->
          </ul>

        </div>
      </div>

    </div>
    <div class="zw" id="tiao1"></div>
    <div class="backimg" :style="{ height: tableHeight + 'px' }">
      <div class="center-content1">
        <div class="banner-box">
          <div class="gsname">北京友数科技有限公司</div>
          <div class="jjname">数据治理&智能制造厂商</div>
          <div class="jjname">推动中国工业高质量制造</div>
        </div>
      </div>
    </div>
    <div class="content" id="tiao2">
      <div class="center-content1">
        <p class="gsjs">公司介绍</p>
        <div class="solid"></div>
        <div class="ms">
          <div class="ms-left">
            <p>
              北京友数科技有限公司（友数科技）成立于2018年，主营业务为数据治理，智能制造两大业务板块。
              友数科技为企业提供数据治理咨询与实施一体化服务，秉承“从理论到实践，再从实践到理论的飞跃”的理念，帮助企业理解数据、融合数据，最终实现全面化数据驱动运营。旗下两大拳头产品设备健康管理平台（PHM）与物流执行系统（LES），帮助制造企业降本增效，精益物料，助力精益生产。
            </p>
          </div>
          <div class="ms-right">
            <img src="./assets/jsimg.png" alt="" class="jsimg" />
          </div>
        </div>
      </div>
    </div>
    <div class="content" id="tiao3">
      <div class="center-content1">
        <p class="gsjs">荣誉资质</p>
        <div class="solid"></div>
        <div class="zizhi">
          <el-carousel :interval="4000" type="card" height="537px" indicator-position="none" >
            <template v-for="(item,index)  in  zsitem">
              <el-carousel-item  :key="item" >
                <div class="img-box">
                  <img :src="item" alt="" :class="index == 0?'row':'col'">
                </div>
              </el-carousel-item>
            </template>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="help" id="tiao4">
      <div style="height:100px; background-color: #ebf9fc;"></div>
      <div class="center-content1">
        <p class="help-text">友数科技数据治理可以帮助您</p>
        <div class="help-cont">
          <div class="duo1">
            <p class="duo-title">规范数据</p>
            <p class="duo-cont"> 建立数据标准体系，对全 <br>业务、全系统范围数据制 <br>定统一的标准</p>
          </div>
          <div class="duo2">
            <p class="duo-title">数据溯源</p>
            <p class="duo-cont"> 基于数据血缘关系，构建 <br>企业数据分布的地图、完 <br>整数据的描述信息</p>
          </div>
          <div class="duo3">
            <p class="duo-title">数据质量</p>
            <p class="duo-cont"> 进行数据质量校验，提高 <br>数据质量，使数据内容详 <br>实、准确、完整</p>
          </div>
          <div class="duo4">
            <p class="duo-title">数据集成</p>
            <p class="duo-cont"> 部署具有海量数据处理能 <br>力的数据集成平台，提供 <br>全面的数据共享</p>
          </div>
          <div class="duo5">
            <p class="duo-title">数据安全</p>
            <p class="duo-cont">对数据存储、传递、使用 <br>进行合理分级授权和加密 <br>脱敏处理，防止敏感数据 <br>滥用</p>
          </div>
        </div>

      </div>
    </div>
    <div style=" background: #ebf9fc;" id="tiao8">
      <div style="height:200px; background-color: #ebf9fc;"></div>
      <div class="advice">
        <div class="center-content1">
          <p class="advice-text">数据治理咨询</p>
          <div class="solid"></div>
          <p class="advice-jieshao">
            围绕数据的全生命周期管理，基于企业数据架构、数据现状的评估，结合行业标杆以及DCMM
            评估的情况，为企业建立符合企业长期数据战略的数据治理方案。通过将流程、策略、标准和组织结构的有效组合，对企业的数字化建设进行全方位的监管，规划设计企业数据管理体系与企业数据标准体系，并结合企业组织结构形成数据管控执行体系，帮助企业健全数据标准以提升管理质量，促进管理闭环以实现降本增效，最终形成数据资产，增强企业核心竞争能力。
          </p>
          <div class="ms">
            <div class="substance">
              <div class="substance-title">
                <img src="./assets/substance.png" alt="" class="substance-img" />
                <p class="substance-text">服务内容</p>
              </div>
              <p class="substance-miaoshu">
                根据DCMM
                对数据治理的领域进行评估，形成企业数据现状诊断分析报告;<br />
                根据组织架构设计数据治理架构，并明确不同组织层级的岗位职责;<br />
                计数据治理管理办法体系,包括数据标准管理办法、数据质量管理办法、元数据管理办法数据安全管理办法等;<br />
                制定企业数据标准，形成数据标准字典。
              </p>
            </div>
            <div class="capacity">
              <div class="capacity-title">
                <img src="./assets/capacity.png" alt="" class="substance-img" />
                <p class="substance-text">数据治理能力</p>
              </div>
              <div class="capacity-miaoshu">
                <div class="capacity-left">
                  <ul class="capacity-ul">
                    <li>大数据治理方案</li>
                    <li>主数据管理方案</li>
                    <li>大数据资产管理方案</li>
                  </ul>
                </div>
                <div class="capacity-right">
                  <ul class="capacity-ul">
                    <li>元数据管理方案</li>
                    <li>数据标准化方案</li>
                    <li>数据质量管控方案</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="tiao9">
      <div style="height:30px; background-color: #ebf9fc;"></div>
      <div class="administer">
        <div class="center-content1">
          <p class="advice-text">数据治理能力</p>
          <div class="solid"></div>
          <div class="administer-text">
            <p>
              多款数据治理产品，为企业打通数据治理各个环节，让企业更“懂”自己，奠定数据基石，实现企业数据资产的沉淀，打造数据驱动业务的
            </p>
            <p>能力，助力企业构建具备企业特色的数据运营体系，形成高质量的数据资产，提升、挖掘数据的应用价值，从而实现企业数据高价值回报。</p>
          </div>
          <div class="keji-lunbo">
            <el-carousel height="400px" :autoplay="false">
              <el-carousel-item class="lunbo-1 keji">
                <div class="innovate_lunbo">
                  <div class="lunbo-img">
                    <img src="./assets/biaozhun.png" alt="">
                  </div>
                  <p class="lunbo-title">数据标准管理</p>
                  <p class="lunbo-cont">建立规范的数据应用标准，消除数据的不一致性，从根 本上改善和解决系统的数据质量问题</p>
                </div>
                <div class="innovate_lunbo">
                  <div class="lunbo-img">
                    <img src="./assets/zhiliang.png" alt="">
                  </div>
                  <p class="lunbo-title">数据质量管理</p>
                  <p class="lunbo-cont">建立规范的数据应用标准，消除数据的不一致性，以数据标准为检核依据，整合质量评估、检核、整改等工作环节，形成完整的数据质量管理闭环</p>
                </div>
                <div class="innovate_lunbo">
                  <div class="lunbo-img">
                    <img src="./assets/zichan.png" alt="">
                  </div>
                  <p class="lunbo-title">数据资产管理</p>
                  <p class="lunbo-cont">数据资产目录式分类管理，提供统一规范的数据服务</p>
                </div>
              </el-carousel-item>
              <el-carousel-item class="lunbo-1 keji">
                <div class="innovate_lunbo">
                  <div class="lunbo-img">
                    <img src="./assets/aqgl.png" alt="">
                  </div>
                  <p class="lunbo-title">数据安全管理</p>
                  <p class="lunbo-cont">通过对敏感数据的加密、脱敏、模糊化处理、分级授权等多种数据安全措施，保障数据安全运转</p>
                </div>
                <div class="innovate_lunbo">
                  <div class="lunbo-img">
                    <img src="./assets/smzq.png" alt="">
                  </div>
                  <p class="lunbo-title">数据生命周期管理</p>
                  <p class="lunbo-cont">记录数据从规划、设计开发、获取与处理、应用及退役的全过程，对数据进行近线归档、离线归档、销毁和全生命周期监控</p>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <div id="tiao5">
      <div style="height:60px; background-color: #ebf9fc;"></div>
        <div class="center-content1" style="background-color: #ebf9fc;width:100%;padding-bottom:60px;">
          <p class="advice-text">智能制造</p>
          <div class="solid"></div>
        </div>
      <div class="manufacture">
        <div class="center-content1">
          <div class="manufacture-img"></div>
        </div>
      </div>
    </div>
    <div class="phm" id="tiao10">
      <div class="center-content1">
        <div class="phm-content">
          <div class="phm-left">
            <p class="phm-title">PHM</p>
            <div class="solid-left"></div>
            <p class="phm-text">
              设备健康管理平台基于物联网技术对设备进行全0方位数据采集，建立设备全生命周期履历信息，进行设备智能健康管理；基于人工智能技术和算法模型，进行设备故障预测性维护，减少设备非计划停产，提升设备使用率，为制造企业达到降本增效的目的。
            </p>
            <ul class="phm-ul">
              <li>维修人员高效管理</li>
              <li>预测性智能维护</li>
              <li>降低点巡检成本</li>
              <li>合理配置备件库存</li>
              <li>专家经验知识库</li>
            </ul>
          </div>
          <div class="phm-right">
            <img src="./assets/phmimg.png" alt="" style="width: 100%;height: 100%;" />
          </div>
        </div>
      </div>
    </div>
    <div class="les" id="tiao11">
      <div class="center-content1">
        <div class="phm-content">
          <div class="phm-right">
            <img src="./assets/lesimg.png" alt="" style="width: 100%;height: 100%;" />
          </div>
          <div class="phm-left">
            <p class="phm-title" style="margin-left: 22px;">LES</p>
            <div class="solid-left"></div>
            <p class="phm-text">
              LES物流执行系统以生产订单为核心，配备物料仓储管理，实现生产订单物料需求计划管理、物料生产拉动，实现物料从入库、出库、库内管理、上料，完成精确装配的物流执行管理系统。系统自动采集记录生产数据，
              提高生产效率，提高仓库管理的效率和透明度， 消除物料各环节浪费。
            </p>
            <ul class="phm-ul">
              <li>降低库存成本，支持准时生产</li>
              <li>全程进度可视化</li>
              <li>精准在库管理</li>
              <li>多物流模式支持</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="custom" id="tiao6">
      <div class="center-content1">
        <p class="advice-text">服务客户</p>
        <div class="solid"></div>
        <table class="custom-all">
          <!-- <tr>
            <td class="custom-all-td"> <img src="./assets/logo/gjsw.png" alt="" style="width:150px"></td>
            <td class="custom-all-td"><img src="./assets/logo/cwb.png" alt="" style="width:180px"></td>
            <td class="custom-all-td"><img src="./assets/logo/gjdw.png" alt="" style="width:150px"></td>
            <td class="custom-all-td"><img src="./assets/logo/gjkf.png" alt="" style="width:150px"></td>
          </tr>
          <tr>
            <td class="custom-all-td"><img src="./assets/logo/zgyd.png" alt="" style="width:150px"></td>
            <td class="custom-all-td"><img src="./assets/logo/zgdx.png" alt="" style="width:150px"></td>
            <td class="custom-all-td"><img src="./assets/logo/zghr.png" alt="" style="width:150px"></td>
            <td class="custom-all-td"><img src="./assets/logo/bjrq.png" alt="" style="width:150px"></td>
          </tr>
          <tr>
            <td class="custom-all-td"><img src="./assets/logo/schk.png" alt="" style="width:150px"></td>
            <td class="custom-all-td"><img src="./assets/logo/lbzg.png" alt="" style="width:150px"></td>
            <td class="custom-all-td"><img src="./assets/logo/ftkms.png" alt="" style="width:150px"></td>
            <td class="custom-all-td"><img src="./assets/logo/zrys.png" alt="" style="width:150px"></td>
          </tr>
          <tr>
            <td class="custom-all-td1"><img src="./assets/logo/zgpa.png" alt="" style="width:150px"></td>
            <td class="custom-all-td1"><img src="./assets/logo/osn.png" alt="" style="width:150px"></td>
            <td class="custom-all-td1"><img src="./assets/logo/ftdml.png" alt="" style="width:150px"></td>
            <td class="custom-all-td1"><img src="./assets/logo/sinid.png" alt="" style="width:80px;height: 60px;"> </td>
          </tr> -->
        </table>
      </div>
    </div>
    <div id="tiao7">
      <div style="height:130px; background-color: #ebf9fc;"></div>
      <div class="contact">
        <div class="center-content1">
          <p class="advice-text">联系我们</p>
          <div class="solid"></div>
          <div class="contact-cont">
            <div class="ditu">
              <!-- <baidu-map :center="center" :zoom="zoom" @ready="handler" style=" width: 900px;height: 400px;"></baidu-map> -->
              <baidu-map :center="center" :zoom="zoom" :scroll-wheel-zoom="true" style="width: 100%; height: 100%"
                @click="getClickInfo" @ready="handler" @moving="syncCenterAndZoom" @moveend="syncCenterAndZoom"
                @zoomend="syncCenterAndZoom">
                <!-- 必须给容器指高度，不然地图将显示在一个高度为0的容器中，看不到 -->
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                  :autoLocation="true"></bm-geolocation>
                <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
              </baidu-map>
            </div>
            <div class="details">
              <p class="p1">北京友数科技有限公司</p>
              <p class="p2">地址: <span class="span">北京市海淀区西三旗昌临801号27号3层302</span></p>
              <p class="p3">邮箱: <span class="span">15210480822@163.com</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <p>@2023 北京友数科技有限公司版权所有
        <img src="./assets/gongan.png" alt="" style="vertical-align: -0.15em;">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802042895"
          target="_blank">京公网安备11010802042895号</a> 
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"> 京ICP备18023538号</a>

      </p>
    </div>
  </div>
</template>
<script>
import zs43 from './assets/certificate/zs43.jpg'
import zs1 from './assets/certificate/zs1.jpg'
import zs2 from './assets/certificate/zs2.jpg'
import zs3 from './assets/certificate/zs3.jpg'



export default {
  name: "App",
  data() {
    return {
      ishidden: false,
      ishidden1: false,
      value: "1",
      center: { lng: 0, lat: 0 },
      zoom: 3,
      //BMap类
      BMap: null,
      //地图对象
      map: null,
      zsitem: [
        zs43,
        zs1,
        zs2,
        zs3
      ],
      tableHeight: 0
    }
  },

  mounted() {
    this.setCurrentHeight()
    window.addEventListener('resize', function () {
      this.setCurrentHeight()
    }.bind(this), false)
  },
  methods: {
    setCurrentHeight() {
      this.tableHeight = window.innerHeight - 64
      console.log(this.tableHeight)

    },
    qiehuan(value) {
      this.value = value
      this.captionChange(value)
      // if (value == '4') {
      //   // this.ishidden = true
      //   // this.ishidden1 = false
      // } else if (value == '5') {
      //   // this.ishidden1 = true
      //   // this.ishidden = false
      // }
    },
    changeActive() {
      this.ishidden = true
    },
    removeActive() {
      this.ishidden = false
    },
    changeActive1() {
      this.ishidden1 = true
    },
    removeActive1() {
      this.ishidden1 = false
    },
    zixun() {
      this.ishidden = false
      this.captionChange('8')
    },
    nengli() {
      this.ishidden = false
      this.captionChange('9')
    },
    tophm() {
      this.ishidden1 = false
      this.captionChange('10')
    },
    toles() {
      this.ishidden1 = false
      this.captionChange('11')
    },
    captionChange(caption) {
      document.getElementById("tiao" + caption).scrollIntoView({ behavior: "smooth", block: 'center' })
    },
    quan() {
      this.ishidden1 = false
      this.ishidden = false
    },
    handler({ BMap, map }) {
      console.log(BMap, map)
      this.BMap = BMap
      this.center.lng = 116.335841
      this.center.lat = 40.058711
      this.zoom = 20
      //保存地图对象
      this.map = map
      //创建定位标记
      // let marker = new BMap.Marker(
      //   new BMap.Point(
      //     116.335841, 40.058711
      //   )
      // )
      // //将标记添加到地图上
      // map.addOverlay(marker)
      var point = new BMap.Point(116.335841, 40.058711);
      // map.centerAndZoom(point, 15);

      var marker = new BMap.Marker(point);  // 创建标注
      map.addOverlay(marker);              // 将标注添加到地图中
      // var opts = {
      //   width: 200,     // 信息窗口宽度
      //   height: 100,     // 信息窗口高度
      //   title: "北京锐银天成科技有限公司", // 信息窗口标题
      // }
      // var infoWindow = new BMap.InfoWindow("地址：北京市海淀区西三旗昌临801号27号3层302", opts);  // 创建信息窗口对象 
      // marker.addEventListener("click", function () {
      //   map.openInfoWindow(infoWindow, point); //开启信息窗口
      // });
    },
    getClickInfo(e) {
      console.log(e)
      // 创建地理编码实例
      const BMap = this.BMap;
      const myGeo = new BMap.Geocoder();
      // 根据坐标逆解析地址
      myGeo.getLocation(new BMap.Point(e.point.lng, e.point.lat), (result) => {
        console.log(result, "result-->>>>");
        if (result) {
          this.address = result.address;
        }
      });
      this.center.lng = e.point.lng;
      this.center.lat = e.point.lat;
    },
    syncCenterAndZoom(e) {
      console.log(e.target, 'e.target-->>>>')
      // const { lng, lat } = e.target.getCenter();
      this.zoom = e.target.getZoom();
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

body {
  min-width: 1100px;
}

.title {
  width: 100%;
  height: 64px;
  background: #ffffff;
  position: fixed;
  z-index: 999;
}

.zw {
  height: 64px;
}

.center-content {
  width: 1274px;
  height: 100%;
  margin: auto;
}

.center-content1 {
  width: 1100px;
  height: 100%;
  margin: auto;
  position: relative;
}

.center-content2 {
  width: 1178px;
  height: 100%;
  margin: auto;
}

.flex {
  display: flex;
  justify-content: space-between;
}

.ding {
  position: relative;
}

.hidden-div {
  width: 200px;
  height: 132px;
  background-color: #ffffff;
  position: absolute;
  top: 63px;
  left: 0;
}

.hidden-div p {
  text-align: center;
  line-height: 66px;
  font-size: 18px;
  color: #05838b;
  cursor: pointer;
}

.hidden-div p:hover {
  background-color: #05838b;
  color: #ffffff;
}

.hidden-div1 {
  width: 200px;
  height: 132px;
  background-color: #ffffff;
  position: absolute;
  top: 63px;
  left: 0;
}

.hidden-div1 p {
  text-align: center;
  line-height: 66px;
  font-size: 18px;
  color: #05838b;
  cursor: pointer;
}

.hidden-div1 p:hover {
  background-color: #05838b;
  color: #ffffff;
}

.img-log {
  width: 136px;
  height: 40px;
  margin-top: 10px;
}

.left-ul {
  position: relative;
  width: auto;
  font-size: 0px;
  display: flex;
}

.left-ul li {
  display: inline-block;
  font-size: 18px;
  padding: 0 40px;
  line-height: 60px;
  color: #636363;
  cursor: pointer;
}

.active {
  height: 57px;
  border-bottom: 7px solid #05838b;
}

.backimg {
  width: 100%;
  height: calc(100vh - 64px);
  /* min-height: 838px; */
  background: url("./assets/backimg.png") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.banner-box {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.gsname {
  padding-bottom: 50px;
  height: 60px;
  font-size: 68px;
  color: #fefefe;
}

.jjname {
  padding-top: 20px;
  height: 60px;
  font-size: 43px;
  color: #fefefe;
}

.content {
  height: 900px;
  background-color: #ebf9fc;
}

.gsjs {
  padding-top: 74px;
  padding-bottom: 30px;
  font-size: 40px;
  color: #6c6e71;
  text-align: center;
}

.solid {
  width: 115px;
  height: 3px;
  background-color: #2976e3;
  margin: auto;
}

.ms {
  margin-top: 100px;
  margin-bottom: 167px;
  display: flex;
  justify-content: space-between;
}

.ms-left {
  width: 505px;
  font-size: 18px;
  line-height: 48px;
  letter-spacing: 2px;
  color: #6c6e71;
  text-indent: 2em;
  padding: 5px;
  margin: 0px;
}

.ms-right {
  width: 422px;
  height: 437px;
}

.jsimg {
  width: 100%;
  height: 100%;
}

.help {
  height: 990px;
  background: url("./assets/help.png") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.help-text {
  padding-top: 104px;
  text-align: center;
  font-size: 40px;
  color: #4a4949;
}

.advice {
  height: 900px;
  background: url("./assets/advice.png") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.advice-text {
  padding-top: 63px;
  padding-bottom: 35px;
  text-align: center;
  font-size: 40px;
  color: #4a4949;
}

.advice-jieshao {
  padding-top: 26px;
  font-size: 18px;
  line-height: 36px;
  color: #6c6e71;
}

.substance {
  width: 50%;
}

.capacity {
  width: 48%;
}

.substance-title {
  width: 200px;
  padding-bottom: 42px;
  margin: auto;
  display: flex;
  justify-content: space-around;
}

.capacity-title {
  width: 250px;
  padding-bottom: 42px;
  margin: auto;
  display: flex;
  justify-content: space-around;
}

.substance-text {
  font-size: 24px;
  line-height: 36px;
  color: #6c6e71;
}

.substance-img {
  width: 30px;
  height: 30px;
}

.substance-miaoshu {
  font-size: 16px;
  line-height: 36px;
  color: #6c6e71;
}

.capacity-miaoshu {
  display: flex;
  justify-content: space-around;
}

.capacity-left {
  width: 250px;
}

.capacity-right {
  width: 220px;
}

.capacity-ul {
  font-size: 16px;
  line-height: 48px;
  color: #6c6e71;
  margin-left: 70px;
}

.administer {
  height: 900px;
  background-color: #ebf9fc;
}

.administer-text {
  margin-top: 60px;
}

.administer-text p {
  font-size: 18px;
  line-height: 36px;
  color: #6c6e71;
  text-align: center;
}

.manufacture {
  background-color: #ebf9fc;
  height: 588px;
}

.manufacture-img {
  width: 100%;
  height: 100%;
  background: url("./assets/manufacture.png");
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  /* background: url("./assets/manufacture.png") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover; */
}

.les {
  background-color: #ebf9fc;
  height: 916px;
}

.phm {
  background-color: #ebf9fc;
  height: 816px;
}

.phm-content {
  padding-top: 214px;
  display: flex;
  justify-content: space-around;
}

.phm-left {
  width: 530px;
}

.phm-title {
  font-size: 40px;
  margin-bottom: 43px;
  color: #6c6e71;
}

.solid-left {
  width: 115px;
  height: 3px;
  background-color: #2976e3;
}

.phm-text {
  margin-top: 63px;
  font-size: 16px;
  line-height: 36px;
  color: #6c6e71;
}

.phm-ul {
  margin: 74px 0 0 25px;
  font-size: 16px;
  line-height: 36px;
  color: #6c6e71;
}

.phm-right {
  width: 403px;
  height: 318px;
  margin-top: 180px;
}

.custom {
  background-color: #ebf9fc;
  height: 600px;
}

.custom-all {
  margin: auto;
  margin-top: 39px;

  height: 366px;
  width: 873px;
  background-image: url('assets/logo/all.png');
  background-size: cover;
}


.custom-all-td {
  text-align: center;
  width: 215px;
  height: 121px;
  background: #ffffff;
  border-right: 1px solid #c1bfbf;
  border-bottom: 1px solid #c1bfbf;
}

.custom-all-td:last-child {
  border-right: 0;
}

.custom-all-td1 {
  text-align: center;
  width: 215px;
  height: 121px;
  background: #ffffff;
  border-right: 1px solid #c1bfbf;
}

.custom-all-td1:last-child {
  border-right: 0;
}

.contact {
  background-color: #ebf9fc;
  height: 1016px;
}

.contact-cont {
  padding-top: 89px;
  width: 1100px;
  display: flex;
  justify-content: space-between;

}

.details {
  width: 530px;
}

.p1 {
  font-size: 26px;
  font-weight: 500;
  padding-top: 60px;
}

.p2 {
  font-size: 18px;
  font-weight: 500;
  padding-top: 40px;
}

.p3 {
  font-size: 18px;
  font-weight: 500;
  padding-top: 20px;
}

.ditu {
  width: 530px;
  height: 320px;
}

.span {
  padding-left: 15px;
}


.iphone p {
  font-size: 18px;
  line-height: 36px;
  color: #6c6e71;
}

.footer {
  height: 64px;
  background-color: #05838b;
}

.footer p {
  text-align: center;
  font-size: 18px;
  line-height: 64px;
  color: #ffffff;
}

.help-cont {
  position: relative;
}

.duo1 {
  width: 268px;
  height: 232px;
  background: url("./assets/duo.png");
  background-size: 100%;
  position: absolute;
  top: 196px;
}

.duo2 {
  width: 268px;
  height: 232px;
  background: url("./assets/duo.png");
  background-size: 100%;
  position: absolute;
  top: 325px;
  left: 207px;
}

.duo3 {
  width: 268px;
  height: 232px;
  background: url("./assets/duo.png");
  background-size: 100%;
  position: absolute;
  top: 196px;
  left: 414px;
}

.duo4 {
  width: 268px;
  height: 232px;
  background: url("./assets/duo.png");
  background-size: 100%;
  position: absolute;
  top: 325px;
  left: 621px;
}

.duo5 {
  width: 268px;
  height: 232px;
  background: url("./assets/duo.png");
  background-size: 100%;
  position: absolute;
  top: 196px;
  left: 828px;
}

.duo-title {
  padding-top: 43px;
  text-align: center;
  font-size: 20px;
  color: #05838b;
}

.duo-cont {
  padding-top: 28px;
  text-align: center;
  font-size: 16px;
  color: #000000;
}

.lunbo-1 {
  display: flex;
  padding: 0 60px;
  align-items: self-end;
}

.keji {
  margin-left: 40px;
}

.keji-lunbo {
  width: 1100px;
  height: 360px;
  margin-top: 80px;
}

.innovate_lunbo {
  float: left;
  margin-right: 50px;
  position: relative;
  width: 270px;
  height: 360px;
  background-color: #ffffff;
  border-radius: 10px;
  background: url("./assets/bian.png") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;

}

.lunbo-img {
  width: 25px;
  height: 26px;
  padding-top: 40px;
  margin: auto;
}

.lunbo-img img {
  width: 100%;
  height: 100%;
}

.lunbo-title {
  text-align: center;
  padding-top: 18px;
  font-size: 18px;
  line-height: 36px;
  color: #373737;
}

.lunbo-cont {
  width: 192px;
  margin: auto;
  padding-top: 20px;
  font-size: 16px;
  line-height: 30px;
  color: #373737;
}

.zizhi {
  height: 537px;
  padding: 60px 0;
}

.zizhi .img-box{
  height: 100%;
  text-align: center;
}

.zizhi .row{
  transform: translateY(20%);
   width: 100%;
}

.zizhi .col{
  width: 381px;
  height: 100%;
}

a {
  color: #ffffff;
  text-decoration: none;
}

/* a:hover{text-decoration:overline; } */
</style>
